import { AxArtwork } from "@dynata/axiom3";
import errorImage from "@dynata/axiom3-images/png/general_error.png";

export function ProjectsError() {
  return (
    <AxArtwork
      title="There was an error loading projects"
      image={errorImage}
      description="Error details"
    />
  );
}
